"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ShoppingBag = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18.7529,17.5742 C18.7159,17.8162 18.5039,18.0002 18.2589,18.0002 L5.7409,18.0002 C5.4959,18.0002 5.2839,17.8162 5.2469,17.5742 L4.0029,9.2872 C3.9879,9.1882 4.0329,9.1192 4.0609,9.0872 C4.0889,9.0542 4.1499,9.0002 4.2499,9.0002 L19.7499,9.0002 C19.8499,9.0002 19.9109,9.0542 19.9399,9.0872 C19.9669,9.1192 20.0119,9.1882 19.9969,9.2872 L18.7529,17.5742 Z M8.9999,7.9982 C8.9999,6.3452 10.3459,5.0002 11.9999,5.0002 C13.6539,5.0002 14.9999,6.3452 14.9999,7.9982 L14.9999,8.0002 L8.9999,8.0002 L8.9999,7.9982 Z M20.6969,8.4342 C20.4589,8.1582 20.1139,8.0002 19.7499,8.0002 L15.9999,8.0002 L15.9999,7.9982 C15.9999,5.7942 14.2059,4.0002 11.9999,4.0002 C9.7949,4.0002 7.9999,5.7942 7.9999,7.9982 L7.9999,8.0002 L4.2499,8.0002 C3.8859,8.0002 3.5409,8.1582 3.3029,8.4342 C3.0649,8.7102 2.9599,9.0752 3.0139,9.4352 L4.2579,17.7222 C4.3679,18.4512 5.0049,19.0002 5.7409,19.0002 L18.2589,19.0002 C18.9949,19.0002 19.6319,18.4512 19.7419,17.7222 L20.9859,9.4352 C21.0399,9.0752 20.9349,8.7102 20.6969,8.4342 L20.6969,8.4342 Z", fillRule: "evenodd" })));
};
ShoppingBag.displayName = 'ShoppingBag';
exports.default = ShoppingBag;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ShoppingBag.js.map